/*
 * Copyright (c) 2024 SARL SIGMA POLYNESIA
 */

import { useForm, UseFormOptions } from '@jalik/react-form'

function useCustomForm<V, E, R> (options: UseFormOptions<V, E, R>) {
  return useForm({
    afterSubmit: 'initialize',
    disableOnSubmit: true,
    disableOnValidate: true,
    nullify: true,
    // reinitialize: true,
    trimOnBlur: false,
    trimOnSubmit: true,
    validateOnChange: false,
    validateOnTouch: true,
    validateOnSubmit: true,
    ...options
  })
}

export default useCustomForm
